import React, { useState, useEffect, useContext, useCallback } from "react";

import gql from "graphql-tag";

import moment from "moment";

import { useHistory, useParams } from "react-router-dom";

import { useApolloClient } from "react-apollo";

import queryString from "query-string";

import { Title, Field, Control, Icon, Button } from "rbx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { ReactTable } from "../../../components/DataTable/DataTable";

import { DRIVER_BOOKING_LIST_COLUMNS } from "./columns";

import "./BookingHistory.scss";

import { downloadCSV } from "../../../utils";

import BookingHistoryFilters from "./BookingHistoryFilters";

import { ModalContext } from "../../../components/ModalProvider";

import { AddBookingForm, EditBookingForm } from "../../../components/Bookings";
import PTOOverview from "./components/PTOOverview";

const ALL_BOOKING_CODES_QUERY = gql`
  query BookingCodes($where: BookingCodeWhereInput) {
    BookingCodes(where: $where) {
      RecId
    }
  }
`;
const ALL_BOOKINGS_QUERY = gql`
  query Bookings($where: BookingWhereInput) {
    Bookings(where: $where, orderByMulti: [PickupDate_DESC]) {
      RecId
      EmployeeRecIdRef
      Reversed
      Employee {
        RecId
        EmployeeId
        FullName
      }
      BookingCodeRecIdRef
      BookingCode {
        RecId
        BookingCode
        Description
      }
      Operator {
        RecId
        UserId
      }
      BookingDate
      PickupDate
      BookedTrip
      Comment
      CreatedDateTime
      CreatedBy
    }
  }
`;

const DriverBookingHistoryPage = () => {
  const client = useApolloClient();
  const history = useHistory();
  const { setModalOpen } = useContext(ModalContext);

  const { id } = useParams();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const query = queryString.parse(history.location.search);

  const [state, setState] = useState({
    // TODO -- UNCOMMENT
    // startDate: moment()
    //   .add(-60, "days")
    //   .format("YYYY-MM-DD"),
    employeeRecId: parseInt(id),
    startDate: moment()
      .startOf("year")
      .format("YYYY-MM-DD"),
    endDate:
      query.date ||
      moment()
        .endOf("day")
        .format("YYYY-MM-DD")
  });

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const where = {
        PickupDate_gt: moment(state.startDate)
          .startOf("day")
          .toISOString(),
        PickupDate_lt: moment(state.endDate)
          .endOf("day")
          .toISOString(),
        EmployeeRecIdRef: parseInt(state.employeeRecId)
      };

      if (state.BookingCodeRecIdRef) {
        where.BookingCodeRecIdRef = parseInt(state.BookingCodeRecIdRef);
      }

      if (state.CodeCatgRecIdRef && state.CodeCatgRecIdRef !== "0") {
        const {
          data: { BookingCodes = [] }
        } = await client.query({
          query: ALL_BOOKING_CODES_QUERY,
          variables: {
            where: {
              CodeCatgRecIdRef: parseInt(state.CodeCatgRecIdRef)
            }
          }
        });
        if (BookingCodes) {
          where.BookingCodeRecIdRef_in = BookingCodes.map(x => x.RecId);
        }
      }

      const {
        data: { Bookings = [] }
      } = await client.query({
        query: ALL_BOOKINGS_QUERY,
        variables: {
          where
        },
        fetchPolicy: "network-only"
      });
      setData(
        Bookings.map(booking => ({
          ...booking,
          PickupDate: moment(booking.PickupDate).format("MM/DD/YY")
        }))
      );
    } catch (err) {
      console.log(err.message);
    } finally {
      setLoading(false);
    }
  }, [
    client,
    state.BookingCodeRecIdRef,
    state.CodeCatgRecIdRef,
    state.employeeRecId,
    state.endDate,
    state.startDate
  ]);

  const handleExport = useCallback(async () => {
    try {
      setExportLoading(true);
      const where = {
        PickupDate_gt: moment(state.startDate)
          .startOf("day")
          .toISOString(),
        PickupDate_lt: moment(state.endDate)
          .endOf("day")
          .toISOString(),
        EmployeeRecIdRef: parseInt(state.employeeRecId)
      };

      if (state.BookingCodeRecIdRef) {
        where.BookingCodeRecIdRef = parseInt(state.BookingCodeRecIdRef);
      }

      if (state.CodeCatgRecIdRef && state.CodeCatgRecIdRef !== "0") {
        const {
          data: { BookingCodes = [] }
        } = await client.query({
          query: ALL_BOOKING_CODES_QUERY,
          variables: {
            where: {
              CodeCatgRecIdRef: parseInt(state.CodeCatgRecIdRef)
            }
          }
        });
        if (BookingCodes) {
          where.BookingCodeRecIdRef_in = BookingCodes.map(x => x.RecId);
        }
      }

      await downloadCSV(
        client,
        {
          query: ALL_BOOKINGS_QUERY,
          where,
          orderByMulti: ["PickupDate_DESC"]
        },
        "Bookings",
        DRIVER_BOOKING_LIST_COLUMNS
      );
    } catch (err) {
      console.log(err.message);
    } finally {
      setExportLoading(false);
    }
  }, [
    client,
    state.BookingCodeRecIdRef,
    state.CodeCatgRecIdRef,
    state.employeeRecId,
    state.endDate,
    state.startDate
  ]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleChange = e => {
    setState(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleComplete = () => {
    fetchData();
    setModalOpen(false, "");
  };
  const handleAddClick = () => {
    setModalOpen(
      true,
      <AddBookingForm
        state={{ EmployeeRecIdRef: state.employeeRecId }}
        onComplete={handleComplete}
      />
    );
  };

  const handleRowClick = bookingData => {
    setModalOpen(
      true,
      <EditBookingForm
        state={{
          RecId: bookingData.RecId,
          EmployeeRecIdRef: bookingData.EmployeeRecIdRef,
          PickupDate: bookingData.PickupDate,
          BookingDate: bookingData.BookingDate,
          BookingCodeRecIdRef: bookingData.BookingCodeRecIdRef,
          BookedTrip: bookingData.BookedTrip,
          Comment: bookingData.Comment,
          CreatedDateTime: bookingData.CreatedDateTime,
          Reversed: bookingData.Reversed
        }}
        onComplete={handleComplete}
      />
    );
  };

  const handlePTOOverviewClick = () => {
    setModalOpen(true, <PTOOverview employeeRecId={state.employeeRecId} />);
  };
  return (
    <div>
      <header className="page-head">
        <div className="page-head-start">
          <Title color="primary" size={3}>
            Booking History
          </Title>
        </div>
        <div className="page-head-end">
          <Field kind="group">
            <Control>
              <Button
                color="link"
                disabled={!state.employeeRecId}
                size="small"
                onClick={handlePTOOverviewClick}
              >
                <Icon>
                  <FontAwesomeIcon icon="info" />
                </Icon>
                <span>PTO</span>
              </Button>
            </Control>
            <Control>
              <Button
                color="primary"
                disabled={exportLoading}
                size="small"
                state={exportLoading ? "loading" : ""}
                onClick={handleExport}
              >
                <Icon>
                  <FontAwesomeIcon icon="file-export" />
                </Icon>
                <span>Export</span>
              </Button>
            </Control>
            <Control>
              <Button color="success" size="small" onClick={handleAddClick}>
                <Icon>
                  <FontAwesomeIcon icon="plus" />
                </Icon>
                <span>Add</span>
              </Button>
            </Control>
          </Field>
        </div>
      </header>
      <div className="booking-history-header">
        <Button
          color="primary"
          onClick={() =>
            history.push("/dispatch/order-dispatching/driver-bookings")
          }
        >
          <Icon>
            <FontAwesomeIcon icon="arrow-left" />
          </Icon>
          <span>Order Dispatching</span>
        </Button>

        <BookingHistoryFilters
          disabled={loading}
          handleChange={handleChange}
          state={state}
        />
      </div>
      <ReactTable
        columns={DRIVER_BOOKING_LIST_COLUMNS}
        data={data}
        initialSortBy={[{ id: "BookingDate", desc: true }]}
        loading={loading}
        onRowClick={handleRowClick}
      />
    </div>
  );
};

DriverBookingHistoryPage.propTypes = {};

export default DriverBookingHistoryPage;
